import List from './views/List.vue'
import Create from './views/CreateEdit.vue'
import Get from './views/Get.vue'

export const CurrencyRoutes = [
  {
    path: '/currencies',
    name: 'ListCurrencies',
    component: List,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'currency:list'
    }
  },
  {
    path: '/currency/',
    name: 'CreateCurrency',
    component: Create,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'currency:create'
    }
  },
  {
    path: '/currency/:id',
    name: 'UpdateCurrency',
    component: Create,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'currency:update'
    }
  },
  {
    path: '/currency/view/:id',
    name: 'GetCurrency',
    component: Get,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'currency:get'
    }
  }
]
